var _defs, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultDas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 320",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2471fe;}.cls-2{fill:#00df9b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "default-das") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36,248.64l.02-.03a104.69258,104.69258,0,0,1,32.83-30.14l.4-.23a131.84879,131.84879,0,0,0,183.17,0l.37.21a104.52112,104.52112,0,0,1,32.9,30.19h0a176.99992,176.99992,0,0,1-249.69,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M259.21,25.83H160.83c-54.25,0-98.38,44.05-98.38,98.19s44.14,98.19,98.38,98.19,98.38-44.05,98.38-98.19a97.43246,97.43246,0,0,0-19.83-58.87A48.89423,48.89423,0,0,0,259.21,25.83ZM160.84,177.27a53.25008,53.25008,0,1,1,53.34-53.25A53.36649,53.36649,0,0,1,160.84,177.27Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultDas);
export default __webpack_public_path__ + "static/media/default-das.be358b7b.svg";
export { ForwardRef as ReactComponent };